import { axios } from 'lib/axios';

export const loginWithPhoneNumberAndPassword = (data) => {
  return axios.post('/auth/login', data);
};

export const loginWithEmailAndPassword = (data) => {
  return axios.post('/auth/login', data);
};
